<template>
  <div
    class="project-structure-train"
    >
    <div
      class="project-structure-train-header"
      @click="$emit('headerClick')"
      @mouseenter.prevent.stop="$emit('enterTrain', train.id)"
      @mouseleave.prevent.stop="$emit('leaveTrain', train.id)"
      >
      <div
        v-if="getAllChildElements({parent_type: 'trains', parent_id: train.id}).length !== 0"
        class="project-structure-train-marker"
        :style="hover || arrayIncludesArray(getAllChildElements({parent_type: 'trains', parent_id: train.id}), hover_el_ids).includes?'background-color: #009688':''"
        />
      <v-btn icon
        @click.prevent.stop="$emit('closeTrain')"
        style="height: 24px; width: 24px"
        >
        <v-icon
          style="cursor: pointer"
          >
          {{train.closed?'keyboard_arrow_right':'keyboard_arrow_down'}}
        </v-icon>
      </v-btn>
      <div
        v-if="!isEditMode"
        >
        {{train.name}}
      </div>
      <input
        v-else
        class="project-structure-tree-input-field"
        :value="train.name"
        @change="$emit('changeValue', {
          key: 'name',
          value: $event.target.value,
          })"
        />
        <div
          class="project-structure-train-delete"
          >
          <slot name="actions"/>
        </div>
    </div>
    <div
      class="project-structure-train-body"
      v-if="!train.closed"
      >
      <slot name="body"/>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: ['train', 'isEditMode', 'hover_el_ids', 'hover' ],
    data: () => ({
    }),
    computed: {
      ...mapGetters('ProjectStructure', [
        'getAllChildElements',
      ]),
    },
    methods: {
      arrayIncludesArray(array1, array2) {
        if (array1.length === 0 || array2.length === 0) {
          return {includes: false, complete: false};
        }
        let set1 = new Set(array1);
        let set2 = new Set(array2);

        function isSuperset(set, subset) {
            for (var elem of subset) {
                if (!set.has(parseInt(elem))) {
                    return false;
                }
            }
            return true;
        }

        if (isSuperset(set1, set2)) {
          return {includes: true, complete: true};
        }

        function intersection(setA, setB) {
            var _intersection = new Set();
            for (var elem of setB) {
                if (setA.has(parseInt(elem))) {
                    _intersection.add(parseInt(elem));
                }
            }
            return _intersection;
        }
        let element_intersection = intersection(set1, set2);

        if (element_intersection.size === 0) {
          // console.log('getVisibility end');
          return {includes: false, complete: false};
        } else {
          // console.log('getVisibility end');
          return {includes: true, complete: false};
        }
      },
    }
  }
</script>
<style>
  .project-structure-train {
    position: relative;
    padding-left: 24px;
    width: 100%;
    overflow: hidden;
  }
  .project-structure-train-header {
    display: flex;
    align-items: center;
    white-space: nowrap;
    user-select: none;
  }
  .project-structure-train-header:hover .project-structure-train-delete {
    display: flex;
  }
  .project-structure-train-delete {
    display: none;
    align-items: center;

  }
  .project-structure-train-body {
    position: relative;
    overflow: auto;
    /* padding-left: 24px; */
  }
  .project-structure-train-marker {
    position: absolute;
    height: 6px;
    width: 6px;
    border-radius: 6px;
    margin-left: -15px;
    margin-right: 9px;
    background-color: rgba(255,255,255, 0.4);
  }
</style>
